import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachNoTotNghiepActionsObj } from "../../action-types/xet-tot-nghiep/IDanhSachNoTotNghiepActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachNoTotNghiepActions = {
    ...generateActions(eDanhSachNoTotNghiepActionsObj, "DANH_SACH_NO_TOT_NGHIEP"),
    ...generateActionForKey(eDanhSachNoTotNghiepActionsObj, "DANH_SACH_NO_TOT_NGHIEP", "LOAD_BY_DOT_XET_ERROR", (m) => { NotifyHelper.Error(m) } ),
}